jQuery('.grid').masonry({
  // options
  itemSelector: '.grid-item',
  columnWidth: 300
});

// REPLACE READ MORE WITH ...
jQuery('.page-children .excerpt-read-more').html("  ");


jQuery("#city-tabs .city-link a").click(function(e){
	e.preventDefault();
	jQuery("#city-tabs .city-link a").removeClass("green");
	var href = jQuery(this).attr('href');
	jQuery(".city-tabs-content .tabs-panel").removeClass("is-active").hide();
	//jQuery(href).addClass("is-active");
	jQuery(href).slideDown("slow", function() {
		jQuery(href).addClass("is-active");
		var city = jQuery(href).attr('id');
		var province = jQuery("#find-advisor .tabs-title.is-active a").attr('data-tabs-target');
		//alert("province is " + province);
		
		var formString = "";
		//jQuery(href + " .city-form").html(formString);
		jQuery(href + " .city-form #gform_1").toggle();
	});
	jQuery(this).addClass("green");
	//console.log('clicked: '+ href);
});

/* 
TOP NAV MOBILE MENU SCRIPT
*/
function myFunction() {
  var x = document.getElementById("myTopnav");
  if (x.className === "topnav") {
    x.className += " responsive";
  } else {
    x.className = "topnav";
  }
}

jQuery(".mobile-menu-icon > a").click(function(){
	var menu = jQuery("#responsive-main-nav");
	var extras = jQuery("#responsive-peripherals");
	jQuery(".toc.sticky").toggle();
	menu.toggleClass("responsive");
	extras.toggleClass("responsive");
});

jQuery(".toc .toc-mobile-icon").click(function(){
	var menu = jQuery(".toc .toc-items");
	menu.toggleClass("responsive");	
});

/*
sticky top bar 
*/
jQuery(document).ready(function() {
	var header = jQuery(".toc").offset();		
	jQuery(".toc-items a").click(function() {
		jQuery(".toc-items").removeClass("responsive");
	});
});

/* 
STICKY SIDEBAR ON PAGES
*/
jQuery(function ($) {
	if ( $("#scroller-anchor").length ) {
    if ($(window).width() > 600) {
		var a = function () {
			var b = $(window).scrollTop();			
			var d = $("#scroller-anchor").offset().top - 64;
			var f = $(".footer").offset().top;
			var c = $(".on-page-toc");
			var h = $(".on-page-toc").height() + 20; // margin
			var r = f - 50;			
			if (b > d) {
				var myTop = $(window).scrollTop();
				if (myTop > r - h) myTop = r - h;			
				c.css({
					position: "absolute",
					top: myTop,
					bottom: ""                
				})
			} else {
				if (b <= d) {				
					c.css({
						position: "absolute",
						top: "",
						bottom: ""
					})
				}
			}		
		};
		$(window).scroll(a);
		a();
	}
	}
});

/*
highlight anchors 
*/

var topRange      = 450,  // measure from the top of the viewport to X pixels down
     edgeMargin    = 75,   // margin above the top or margin from the end of the page
     animationTime = 1000, // time in milliseconds
     contentTop = [];

jQuery(document).ready(function($){ 

	// Stop animated scroll if the user does something
	$('html,body').bind('scroll mousedown DOMMouseScroll mousewheel keyup', function(e){
		if ( e.which > 0 || e.type == 'mousedown' || e.type == 'mousewheel' ){
			$('html,body').stop();
		}
	});
	
	$('.toc-items').find('a').each(function(){
		contentTop.push( $( $(this).attr('href') ).offset().top );
	});
	
	 // Animate menu scroll to content
	$('.toc-items').find('a').click(function(){
		var sel = this,
		newTop = Math.min( contentTop[ $('.toc-items a').index( $(this) ) ], $(document).height() - $(window).height() ); // get content top or top position if at the document bottom
		var topOffset = newTop - 400;
		$('html,body').stop().animate({ scrollTop : topOffset }, animationTime);
	return false;
	});
	
	// adjust side menu
	$(window).scroll(function(){
	var winTop = $(window).scrollTop(),
	bodyHt = $(document).height(),
	vpHt = $(window).height() + edgeMargin;  // viewport height + margin
		$.each( contentTop, function(i,loc){
			if ( ( loc > winTop - edgeMargin && ( loc < winTop + topRange || ( winTop + vpHt ) >= bodyHt ) ) ){
				$('.toc-items a')
				.removeClass('is-active')
				.eq(i).addClass('is-active');
			}
		});
	});
	
});

/* OFFSETTING ANCHOR LANDING POINTS */
window.addEventListener("hashchange", function () {
    window.scrollTo(window.scrollX, window.scrollY - 100);
});

(function($) {
  $('a[href*=\\#]:not([href=\\#])').not("a.prov").not("a.cityLocation").click(function() 
  {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') 
        || location.hostname == this.hostname) 
    {      
      var target = $(this.hash),
      headerHeight = $(".header").height() + 25; // Get fixed header height            
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');              
      if (target.length) 
      {
        $('html,body').animate({
          scrollTop: target.offset().top - headerHeight
        }, 500);
        return false;
      }
    }
  });
})(jQuery);